import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const requestMagicLinkSchema = z.object({
  email: z.string().email(),
  redirect: z.string().optional(),
});

export class RequestMagicLinkDto extends createZodDto(requestMagicLinkSchema) {}

